module.exports = __webpack_public_path__ + "img/BeachFest 2020_Web_Alpha-Light.edc29992.png";